import * as ACTION from '../constants';
import * as saga from './saga';
import {takeEvery, takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.REMOVE_STAFF_IN_WAREHOUSE.REQUEST, saga.removeStaffInWarehouse);
	yield takeEvery(ACTION.REMOVE_STAFF_IN_WAREHOUSE.SUCCESS, saga.removeStaffInWarehouseSuccess);
	yield takeLatest(ACTION.REMOVE_STAFF_IN_WAREHOUSE.FAILED, saga.removeStaffInWarehouseFailed);
}
